import { inject, injectable } from "inversify";
import { Either } from "@core/domain/types/either";
import { FallbackError } from "@core/domain/errors/fallback.error";
import { ValidationError } from "@core/domain/errors/validation.error";
import { FinancialEntityBudget } from "@project/domain/models/budget/financial-entity-budget.model";
import { MarkAsTemplate } from "@project/domain/models/budget-template/mark-as-template";
import { BudgetTemplateRepositoryAbstract } from "@project/domain/repositories/budget-template.repository.abstract";

@injectable()
export class MarkAsTemplateUseCase {
    constructor(
        @inject(BudgetTemplateRepositoryAbstract)
        private readonly budgetTemplateRepository: BudgetTemplateRepositoryAbstract,
    ) { }

    async execute(markAsTemplate: MarkAsTemplate): Promise<Either<ValidationError | FallbackError, FinancialEntityBudget>> {
        return await this.budgetTemplateRepository.markAsTemplate(markAsTemplate);
    }
}
